/**
 * Turning a presigned S3 object into bytes the page can own.
 *
 * Shared by the PDF export (jsPDF needs bytes, not a URL) and by signatures,
 * which are inlined for two reasons: html2canvas runs with `allowTaint` off, so
 * a cross-origin image is silently dropped from the exported PDF, and a
 * presigned URL expires while a claim sits open on screen. A data URL has
 * neither problem.
 */
export async function toDataUrl(url: string): Promise<string | null> {
  try {
    const response = await fetch(url);
    if (!response.ok) return null;
    const blob = await response.blob();
    return await new Promise<string | null>((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : null);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch {
    // Reading the bytes needs CORS on the bucket. Without it the fetch fails,
    // and the caller falls back to the plain URL — which still *displays*,
    // because an <img> needs no CORS to paint.
    return null;
  }
}
